export const Types = {
  RESET_DATA: "bankAccountFarm/RESET_DATA",
  SHOW_HIDE_DRAWER_BANK_ACCOUNT_FARM:
    "bankAccountFarm/SHOW_HIDE_DRAWER_BANK_ACCOUNT_FARM",
  FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM:
    "bankAccountFarm/FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM",
  FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM_SUCCESS:
    "bankAccountFarm/FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM_SUCCESS",
  FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM_ERROR:
    "bankAccountFarm/FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM_ERROR",
  FETCH_TABLE_DATA_BANK_ACCOUNT_FARM:
    "bankAccountFarm/FETCH_TABLE_DATA_BANK_ACCOUNT_FARM",
  FETCH_TABLE_DATA_BANK_ACCOUNT_FARM_SUCCESS:
    "bankAccountFarm/FETCH_TABLE_DATA_BANK_ACCOUNT_FARM_SUCCESS",
  FETCH_TABLE_DATA_BANK_ACCOUNT_FARM_ERROR:
    "bankAccountFarm/FETCH_TABLE_DATA_BANK_ACCOUNT_FARM_ERROR",
  SAVE_BANK_ACCOUNT_FARM: "bankAccountFarm/SAVE_BANK_ACCOUNT_FARM",
  SAVE_BANK_ACCOUNT_FARM_SUCCESS:
    "bankAccountFarm/SAVE_BANK_ACCOUNT_FARM_SUCCESS",
  SAVE_BANK_ACCOUNT_FARM_ERROR: "bankAccountFarm/SAVE_BANK_ACCOUNT_FARM_ERROR",
};

export const Creators = {
  switchDrawerBankAccountFarmVisibility: (data = null) => ({
    type: Types.SHOW_HIDE_DRAWER_BANK_ACCOUNT_FARM,
    payload: {
      data,
    },
  }),
  getBankAccountFarm: (groupId, farmId) => ({
    type: Types.FETCH_TABLE_DATA_BANK_ACCOUNT_FARM,
    payload: {
      groupId,
      farmId,
    },
  }),
  getBankAccountFarmSuccess: (data) => ({
    type: Types.FETCH_TABLE_DATA_BANK_ACCOUNT_FARM_SUCCESS,
    payload: {
      data,
    },
  }),
  getBankAccountFarmError: (error) => ({
    type: Types.FETCH_TABLE_DATA_BANK_ACCOUNT_FARM_ERROR,
    payload: {
      error,
    },
  }),
  getDropdownBankAccountFarm: (groupId, farmId) => ({
    type: Types.FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM,
    payload: {
      groupId,
      farmId,
    },
  }),
  getDropdownBankAccountFarmSuccess: (data) => ({
    type: Types.FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM_SUCCESS,
    payload: {
      data,
    },
  }),
  getDropdownBankAccountFarmError: (error) => ({
    type: Types.FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM_ERROR,
    payload: {
      error,
    },
  }),

  saveBankAccountFarm: (groupId, farmId, id = null, body) => ({
    type: Types.SAVE_BANK_ACCOUNT_FARM,
    payload: {
      groupId,
      farmId,
      id,
      body,
    },
  }),
  saveBankAccountFarmSuccess: (data) => ({
    type: Types.SAVE_BANK_ACCOUNT_FARM_SUCCESS,
    payload: {
      data,
    },
  }),
  saveBankAccountFarmError: (error) => ({
    type: Types.SAVE_BANK_ACCOUNT_FARM_ERROR,
    payload: {
      error,
    },
  }),
};

const INITIAL_STATE = {
  isBankAccountFarmDrawerVisible: false,
  bankAccountFarmData: null,
  bankAccountFarmTableData: null,
  loadingBankAccountFarmTableData: false,
  bankAccountFarmDropdownData: null,
  loadingBankAccountFarmDrowpdownData: false,
};

export default function bankAccountFarm(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.RESET_DATA:
      return INITIAL_STATE;
    case Types.SHOW_HIDE_DRAWER_BANK_ACCOUNT_FARM:
      return {
        ...state,
        isBankAccountFarmDrawerVisible: !state.isBankAccountFarmDrawerVisible,
        bankAccountFarmData: action.payload.data,
      };
    case Types.SAVE_BANK_ACCOUNT_FARM:
      return { ...state, loadingBankAccountFarmTableData: true };
    case Types.SAVE_BANK_ACCOUNT_FARM_SUCCESS:
      return {
        ...state,
        loadingBankAccountFarmTableData: false,
        isBankAccountFarmDrawerVisible: !state.isBankAccountFarmDrawerVisible,
      };
    case Types.SAVE_BANK_ACCOUNT_FARM_ERROR:
      return {
        ...state,
        loadingBankAccountFarmTableData: false,
      };
    case Types.FETCH_TABLE_DATA_BANK_ACCOUNT_FARM:
      return {
        ...state,
        loadingBankAccountFarmTableData: true,
      };
    case Types.FETCH_TABLE_DATA_BANK_ACCOUNT_FARM_SUCCESS:
      return {
        ...state,
        bankAccountFarmTableData: action.payload.data,
        loadingBankAccountFarmTableData: false,
      };
    case Types.FETCH_TABLE_DATA_BANK_ACCOUNT_FARM_ERROR:
      return {
        ...state,
        bankAccountFarmTableData: null,
        loadingBankAccountFarmTableData: false,
      };
    case Types.FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM:
      return {
        ...state,
        loadingBankAccountFarmDrowpdownData: true,
      };
    case Types.FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM_SUCCESS:
      return {
        ...state,
        bankAccountFarmDropdownData: action.payload.data,
        loadingBankAccountFarmDrowpdownData: false,
      };
    case Types.FETCH_DROPDOWN_DATA_BANK_ACCOUNT_FARM_ERROR:
      return {
        ...state,
        bankAccountFarmDropdownData: null,
        loadingBankAccountFarmDrowpdownData: false,
      };
    default:
      return state;
  }
}
